export const envVars = {
  ...import.meta.env,
  VITE_BASE_STORAGE_URL: import.meta.env.VITE_BASE_STORAGE_URL?.endsWith('/')
    ? import.meta.env.VITE_BASE_STORAGE_URL?.slice(0, -1)
    : import.meta.env.VITE_BASE_STORAGE_URL,
};
